export default __webpack_public_path__ + "static/media/menu-m@2x.f6b5bb35.png";